import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLanguageStore = defineStore('language', () => {
  const language = ref('en') // Default language is English

  // Function to change the language
  function setLanguage(lang) {
    language.value = lang
  }

  return { language, setLanguage }
})